import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'antd';

const SavedJobChartsList = props => {
  const { savedJobcharts, viewSavedJobChartsModal, hideModal } = props;

  const columns = useMemo(() => {
    const column = [
      // {
      //   title: 'Save #',
      //   dataIndex: 'id',
      //   width: '10%',
      // },
      {
        title: 'Customer',
        dataIndex: 'customer',
        width: '80%',
      },
      {
        title: 'BPO #',
        dataIndex: 'bpoNo',
        width: '20%',
      },
    ];

    return column;
  }, []);

  const rowKey = useMemo(() => record => record.id, []);

  return (
    <Modal
      visible={viewSavedJobChartsModal}
      onCancel={hideModal}
      title="Saved Jobcharts"
      width="60%"
      maskClosable={false}
      footer={false}
      style={{ top: 10 }}
    >
      <Table
        bordered
        size="small"
        columns={columns}
        dataSource={savedJobcharts}
        rowKey={rowKey}
        pagination={false}
      />
    </Modal>
  );
};

SavedJobChartsList.propTypes = {
  savedJobcharts: PropTypes.array,
  viewSavedJobChartsModal: PropTypes.bool,
  hideModal: PropTypes.func,
};

export default SavedJobChartsList;
